import Vue from 'vue'
import config from '@/config/index'

export default {
	namespaced: true,
	actions: {
    recalculateWages ({ commit, dispatch }, payload) {
      console.log('actions recalculateWages', payload)
      return Vue.axios.get(`${config.serverURI}/wages/recalculate/${payload}`)
    },
  }
}


// WEBPACK FOOTER //
// ./src/store/modules/wage.js